module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "announcement announcement--demo"
  }, [_c('router-link', {
    staticClass: "announcement__logo",
    attrs: {
      "to": {
        name: 'logout',
        params: {
          _internal: true
        },
        query: {
          next: 'web'
        }
      }
    }
  }, [_c('span', {
    staticClass: "announcement__icon"
  }), _c('span', {
    staticClass: "announcement__app-name"
  }, [_vm._v("Kiempunt")])]), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('span', {
    staticClass: "announcement__inquiry"
  }, [_vm._v("Kiempunt uitproberen in de klas? "), _c('a', {
    staticClass: "button--inquiry button-timid button-forward ",
    attrs: {
      "href": "/proef/demo"
    }
  }, [_vm._v("Vraag gratis proefperiode aan")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf43d506","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/elements/DemoMessage.vue
// module id = f3MT
// module chunks = 0 1